import { render, staticRenderFns } from "./PaymentDocumentsEmailForm.vue?vue&type=template&id=83d4feee&scoped=true&"
import script from "./PaymentDocumentsEmailForm.vue?vue&type=script&lang=ts&"
export * from "./PaymentDocumentsEmailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d4feee",
  null
  
)

export default component.exports